import React from 'react';

import { Box } from '@mui/material';

export const GeneralBackground = () => (
  <Box
    sx={(theme) => ({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '500px',
      backgroundColor: theme.palette.background.clay,
      zIndex: 0,
    })}
  />
);
